export default __webpack_public_path__ + "bb94c5836b3fd7d86c469b5957aa7df4.woff2";